import { ETransactionMethod, ETransactionStatus } from '@xeppt/xeppt-sdk/types/transaction';
import { ECardStatus } from '@xeppt/xeppt-sdk/types';
import { EPaymentIntentStatus } from '@xeppt/xeppt-sdk/types/payment-intent';

export const enumTranslate = {
    // [ETransactionMethod.EPS]: {
    //     en: 'Payment',
    //     fr: 'Paiement'
    // },
    [ETransactionMethod.E_TRANSFER]: {
        en: 'Interac E-Transfer',
        fr: 'Interac E-Transfer'
    },
    [ETransactionMethod.WALLET]: {
        en: 'XEPPT wallet',
        fr: 'portefeuille'
    },
    [ETransactionMethod.EFT]: {
        en: 'Bank',
        fr: 'Virement depuis la banque'
    },
    [ETransactionMethod.PAY_BILL]: {
        en: 'Bill payment',
        fr: 'Paiement de facture'
    },
    [ETransactionMethod.EPS]: {
        en: 'Linked card',
        fr: 'Linked card'
    },
    [ETransactionMethod.CARD]: {
        en: 'Prepaid card',
        fr: 'Prepaid card'
    },
    [ETransactionMethod.GIFT_CARD]: {
        en: 'Gift card',
        fr: 'Gift card'
    }
};

export const enumRecipientTranslate = {
    // [ETransactionMethod.EPS]: {
    //     en: 'Payment',
    //     fr: 'Paiement'
    // },
    [ETransactionMethod.E_TRANSFER]: {
        en: 'External contact',
        fr: 'External contact'
    },
    [ETransactionMethod.WALLET]: {
        en: 'XEPPT contact',
        fr: 'XEPPT contact'
    },
    [ETransactionMethod.EFT]: {
        en: 'Linked bank account',
        fr: 'Linked bank account'
    },
    [ETransactionMethod.PAY_BILL]: {
        en: 'Payee',
        fr: 'Payee'
    },
    [ETransactionMethod.EPS]: {
        en: 'Linked card',
        fr: 'Linked card'
    },
    [ETransactionMethod.CARD]: {
        en: 'XEPPT prepaid card',
        fr: 'XEPPT prepaid card'
    },
    [ETransactionMethod.GIFT_CARD]: {
        en: 'Gift card',
        fr: 'Gift card'
    }
};

export const ETransactionStatusTranslate = {
    [ETransactionStatus.PENDING]: {
        en: 'Pending',
        fr: 'En attente'
    },
    [ETransactionStatus.APPROVED]: {
        en: 'Approved',
        fr: 'Approuvée'
    },
    [ETransactionStatus.DECLINED]: {
        en: 'Declined',
        fr: 'Refusé'
    },
    [ETransactionStatus.CANCELED]: {
        en: 'Canceled',
        fr: 'Annulé'
    },
    [ETransactionStatus.REFUND]: {
        en: 'Refunded',
        fr: 'Refunded'
    },
    [ETransactionStatus.RETURNED]: {
        en: 'Returned',
        fr: 'Returned'
    },
    [ETransactionStatus.EXPIRED]: {
        en: 'Expired',
        fr: 'Expired'
    },
    [ETransactionStatus.ERROR]: {
        en: 'Declined',
        fr: 'Refusé'
    }
};

export const EIntentStatusTranslate = {
    [EPaymentIntentStatus.Pending]: {
        en: 'Pending',
        fr: 'Pending'
    },
    [EPaymentIntentStatus.InProcess]: {
        en: 'In process',
        fr: 'In process'
    },
    [EPaymentIntentStatus.Paid]: {
        en: 'Paid',
        fr: 'Paid'
    },
    [EPaymentIntentStatus.Expired]: {
        en: 'Expired',
        fr: 'Expired'
    },
    [EPaymentIntentStatus.Canceled]: {
        en: 'Canceled',
        fr: 'Canceled'
    },
    [EPaymentIntentStatus.Declined]: {
        en: 'Declined',
        fr: 'Declined'
    },
    [EPaymentIntentStatus.Unknown]: {
        en: 'Unknown',
        fr: 'Unknown'
    }
};

export const ECardStatusTranslation = {
    [ECardStatus.FRAUD]: {
        en: 'Fraud',
        fr: 'Fraude'
    },
    [ECardStatus.STOLEN]: {
        en: 'Stolen',
        fr: 'Volé'
    },
    [ECardStatus.OTHER]: {
        en: 'Other',
        fr: 'Autre'
    },
    [ECardStatus.LOST]: {
        en: 'Lost',
        fr: 'Perdu'
    },
    [ECardStatus.CUSTOMER_REQUEST]: {
        en: 'Customer request',
        fr: 'Demande du client'
    }
};
